import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from "rxjs/Rx";
import { AuthenticationService } from '../_services';
import { UsersDataService } from 'core/data-services/users/users.service';
import { Helpers } from 'helpers';
import {MainAlertService} from 'helpers/services/main-alert.service';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(private _router: Router,
              private _authService: AuthenticationService,
              private _userService: UsersDataService,
              private _alertService: MainAlertService
              ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    return this.checkActivate(state);
  }

  canActivateChild (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    return this.checkActivate(state);
  }

  checkActivate (state: RouterStateSnapshot) {
    const api_token = localStorage.getItem('token');
    const userProfile = JSON.parse(localStorage.getItem('userInfo'));
    if (!api_token) {
      this._authService.logout();
      this._router.navigate(['/login'], {queryParams: {returnUrl: state.url}});
      return false;
    }
    if (!userProfile) {
      return Observable.fromPromise(
        this._userService.getUserProfile()
          .then(response => {
            localStorage.setItem('userInfo', JSON.stringify(response));
            return true;
          }).catch(error => {
          this._authService.logout();
          Helpers.setLoading(false);
          this._alertService.alertCustomError("กรุณาลองใหม่อีกครั้ง");
          return false;
        })
      )
    } else {
      return true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/authentication/_guards/auth.guard.ts